import { Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import useDesvincularUnidadeGrupo from "core/features/grupo-unidades/hooks/useDesvincularUnidadeGrupo";
import useDetalheGrupoUnidade from "core/features/grupo-unidades/hooks/useDetalheGrupoUnidade";
import { GrupoUnidadeDetalheUnidadeItem } from "core/features/grupo-unidades/typings";
import useUnidade from "core/features/unidades/useUnidade";
import { showErrorAxios } from "infra/helpers/alerta";
import useFiltro from "infra/helpers/useFiltro";
import { useEffect, useState } from "react";
import NewTable from "ui/components/NewTable";
import PageHeader from "ui/components/Page/PageHeader";
import Sidebar from "ui/components/Page/Sidebar";
import EditUnidade from "ui/components/Features/Unidades/components/EditUnidade";
import UnidadeDetails from "ui/components/Features/Unidades/components/UnidadeDetails";
import HeaderTable from "./components/HeaderTable";
import ModalVincularUnidade from "./components/ModalVincularUnidade";
import useDetalhesGrupoColumns from "./hooks/useDetalhesGrupoColumns";

function DetalhesGrupo({
  id,
  nome,
  onLoadGrupo,
}: {
  id: string;
  nome: string;
  onLoadGrupo: (nome: string) => any;
}) {
  const { filtro, onChangeFiltro } = useFiltro();
  const [selectedUnidadeId, setSelectedUnidadeId] = useState<
    string | undefined
  >(undefined);

  const [editUnidadeModalOpen, setEditUnidadeModalOpen] = useState(false);
  const [editUnidadeId, setEditUnidadeId] = useState<string | undefined>(
    undefined
  );
  const [isOpenModal, setIsOpenModal] = useState(false);

  const {
    data: selectedUnidade,
    isLoading: isLoadingSelectedUnidade,
    isFetching: isFetchingSelectedUnidade,
    refetch: refetchSelectedUnidade,
  } = useUnidade(selectedUnidadeId);

  const { mutate: desvincularUnidade, isLoading: isLoadingDesvincular } =
    useDesvincularUnidadeGrupo(id);

  const { tenant } = useCurrentTenant();

  const { data, isLoading, isFetching, refetch } = useDetalheGrupoUnidade(
    id,
    filtro.page,
    filtro.search
  );

  useEffect(() => {
    if (data?.nome) {
      onLoadGrupo(data.nome);
    }
  }, [data, onLoadGrupo]);

  const columns = useDetalhesGrupoColumns();

  const _isLoading = isLoading || isFetching || isLoadingDesvincular;

  const onSearch = (v?: string) => onChangeFiltro("search", v);

  return (
    <>
      <PageHeader
        title={nome}
        titleButton="Vincular unidade ao grupo"
        onClick={() => setIsOpenModal(true)}
      />

      <Box as={Row} gutter={32}>
        <Col sm={selectedUnidadeId ? 17 : 24}>
          <NewTable<GrupoUnidadeDetalheUnidadeItem>
            title={() => (
              <HeaderTable value={filtro.search || ""} onSearch={onSearch} />
            )}
            loading={_isLoading}
            columns={columns}
            dataSource={data?.items}
            onRow={(record: GrupoUnidadeDetalheUnidadeItem) => ({
              onClick: () => setSelectedUnidadeId(record.id),
              style: {
                cursor: "pointer",
              },
            })}
            customPagination={{
              currentPage: data?.meta.currentPage ?? 0,
              itemsPerPage: data?.meta.itemsPerPage ?? 0,
              totalItems: data?.meta.totalItems ?? 0,
              onChangePage: (page: number) => {
                onChangeFiltro("page", page);
              },
            }}
            actions={[
              {
                title: "Desvincular",
                onClick: (v: GrupoUnidadeDetalheUnidadeItem) => {
                  desvincularUnidade(
                    { unidadeId: v.id },
                    {
                      onSuccess: () => refetch(),
                      onError: (e) => {
                        showErrorAxios(e);
                      },
                    }
                  );
                },
              },
            ]}
          />
        </Col>
        {selectedUnidadeId ? (
          <Box as={Col} sm={7} pt={8}>
            <Sidebar>
              <UnidadeDetails
                onEdit={() => {
                  setEditUnidadeModalOpen(true);
                  setEditUnidadeId(selectedUnidadeId);
                }}
                unidade={selectedUnidade || undefined}
                loading={isLoadingSelectedUnidade || isFetchingSelectedUnidade}
              />
            </Sidebar>
          </Box>
        ) : null}
      </Box>

      <ModalVincularUnidade
        visible={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        idGrupo={id}
        onSuccess={refetch}
      />

      <EditUnidade
        tenantId={tenant.id!}
        isOpenModal={editUnidadeModalOpen}
        onClose={() => setEditUnidadeModalOpen(false)}
        unidadeEditId={editUnidadeId}
        onSuccess={() => {
          refetchSelectedUnidade();
          refetch();
          setEditUnidadeModalOpen(false);
        }}
      />
    </>
  );
}

export default DetalhesGrupo;
